<template>
  <div>
    <!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
    <div
      class="flex flex-row items-start justify-between space-x-4 cursor-pointer hover:opacity-50"
      @click="toggleOpen"
    >
      <slot name="header" />
      <div class="aspect-1 flex items-center justify-center">
        <fa
          :icon="['fal', 'angle-down']"
          class="text-xl text-ocean-900 mt-1.5 duration-150"
          :class="open ? 'rotate-180' : ''"
        />
      </div>
    </div>
    <transition name="fade-fast">
      <div v-show="open">
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'VetsterCollapse',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      open: this.isOpen,
    };
  },

  computed: {
    angleIconColor() {
      return '';
    },
  },

  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
  },
};
</script>
